export const DottedLine = () => {
    return (
        <svg width="2" height="30" viewBox="0 0 2 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.6" d="M1 30L1 -1.19209e-06" stroke="#5F5F5F" strokeWidth="2" strokeDasharray="5 5"/>
        </svg>
    );
};